export var defaultCharsRules = {
  '9': '[0-9]',
  'a': '[A-Za-z]',
  '*': '[A-Za-z0-9]'
};
export var defaultMaskChar = '_';


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-input-mask/es/constants/index.js
// module id = 97
// module chunks = 0